import React from "react";

const Nav = ({children}) => {
	return (
		<>{children}</>
		// <header className="main--nav d-flex flex-column">
		// 	{/* Background  */}
		// 	<div
		// 		className="mask lazyload"
		// 		data-bg="assets/images/gold-pattern.png"
		// 	></div>

		// 	{/* Site Logo  */}
		// 	<a className="logo" href="#">
		// 		<img
		// 			className="lazyload"
		// 			data-src="assets/images/logo-en.png"
		// 			alt="Warshatna"
		// 		/>
		// 	</a>

		// 	{/* Nav  */}
		// 	<nav className="custom--scrollbar">
		// 		<ul className="nav-side">
		// 			<li className="active">
		// 				<a href="#">
		// 					<div
		// 						className="item icon-my-dashboard-warshatna"
		// 						title="My Dashboard"
		// 					>
		// 						<span>My Dashboard</span>
		// 					</div>
		// 				</a>
		// 			</li>
		// 			<li>
		// 				<a href="#">
		// 					<div
		// 						className="item icon-my-profile-warshatna"
		// 						title="My Profile"
		// 					>
		// 						<span>My Profile</span>
		// 					</div>
		// 				</a>
		// 			</li>
		// 			<li>
		// 				<a href="#">
		// 					<div
		// 						className="item icon-my-products-warshatna"
		// 						title="My Products"
		// 					>
		// 						<span>My Products</span>
		// 					</div>
		// 				</a>
		// 			</li>
		// 			<li>
		// 				<a href="#">
		// 					<div className="item icon-inquiries-warshatna" title="Inquiries">
		// 						<span>Inquiries</span>
		// 					</div>
		// 				</a>
		// 			</li>
		// 			<li>
		// 				<a href="#">
		// 					<div className="item icon-bids-warshatna" title="Bids">
		// 						<span>Bids</span>
		// 					</div>
		// 				</a>
		// 			</li>
		// 			<li>
		// 				<a href="#">
		// 					<div
		// 						className="item icon-opportunities-warshatna"
		// 						title="Opportunities"
		// 					>
		// 						<span>Opportunities</span>
		// 					</div>
		// 				</a>
		// 			</li>
		// 			<li>
		// 				<a href="#">
		// 					<div className="item icon-jobs-warshatna" title="Jobs">
		// 						<span>Jobs</span>
		// 					</div>
		// 				</a>
		// 			</li>
		// 			<li>
		// 				<a href="#">
		// 					<div className="item icon-users-warshatna" title="Users">
		// 						<span>Users</span>
		// 					</div>
		// 				</a>
		// 			</li>
		// 			<li>
		// 				<a href="#">
		// 					<div
		// 						className="item icon-violations-warshatna"
		// 						title="Violations"
		// 					>
		// 						<span>Violations</span>
		// 					</div>
		// 				</a>
		// 			</li>
		// 			<li>
		// 				<a href="#">
		// 					<div className="item icon-reports-warshatna" title="Reports">
		// 						<span>Reports</span>
		// 					</div>
		// 				</a>
		// 			</li>
		// 			<li>
		// 				<a href="#">
		// 					<div
		// 						className="item icon-switch-profile-warshatna"
		// 						title="Switch Profile "
		// 					>
		// 						<span>Switch Profile </span>
		// 					</div>
		// 				</a>
		// 			</li>
		// 		</ul>
		// 	</nav>

		// 	{/* Nav Actions  */}
		// 	<ul className="nav-side mt-5">
		// 		<li>
		// 			<a href="#">
		// 				<div className="item icon-help-warshatna" title="Help">
		// 					<span>Help</span>
		// 				</div>
		// 			</a>
		// 		</li>
		// 		<li>
		// 			<a href="#">
		// 				<div className="item icon-logout-warshatna" title="Logout">
		// 					<span>Logout</span>
		// 				</div>
		// 			</a>
		// 		</li>
		// 	</ul>
		// </header>
	);
};

export default Nav;
